import { Injectable } from '@angular/core';
import { AccountService } from '../../services/account.service';
import { ImageSyncApiService } from '../../typescript-angular-client/api/imageSync.service';

@Injectable({
  providedIn: 'root'
})
export class ImageSyncService {
  constructor(
    private imageSyncService: ImageSyncApiService,
    private accountService: AccountService
  ) { }

  public syncImages(email: string) {
    return this.imageSyncService.syncImages(this.accountService.accountKey, email)
  }
}
